import { useState } from "react";
import { Link } from "react-router-dom";
import close from "../../assets/img/close.png";
import "./style.scss";
// 内容
const UseGoodsMain = (props: any) => {
  let {
    checkedGoodsData,
    productList,
    checkedProductData,
    specID,
    setSpecID,
    goodsSpecID,
    setGoodsSpecID,
    payMoney,
    setAccount,
    account
  } = props;
  // console.log("选择的商品详情 =>", checkedGoodsData);
  // console.log("productList =>", productList);
  // console.log("checkedProductData =>", checkedProductData);

  const [showReadme, setShowReadme] = useState(false);

  // 规格title 选中
  const checkedTitle = (data: string) => {
    if (setSpecID) setSpecID(data);
  };

  // 规格商品的选中
  const checkedGoodsSpec = (data: number) => {
    if (setGoodsSpecID) setGoodsSpecID(data);
  };

  return (
    <div className="goods-main-box">
      <div className="goods-head">
        <div className="goods-head-cover-right"></div>
        <div className="goods-head-cover-left"></div>
        <div className="goods-head-input">
          <input
            type="text"
            placeholder="请输入正确的账号"
            className="tel-number"
            maxLength={11}
            value={account}
            onChange={(val) => setAccount(val.target.value)}
          />
          <div className="delete-icon" onClick={() => setAccount("")}></div>
        </div>

        <img
          src={checkedGoodsData.bg_spec_top}
          alt=""
          className="goods-head-bg"
        />
      </div>

      <div
        className="goods-main"
        style={{ backgroundColor: checkedGoodsData.bg_spec_val_body }}
      >
        {/* 商品title */}
        <div className="goods-title-list">
          {productList?.map((item: any) => {
            return (
              <span
                className={
                  item.spec_id === specID
                    ? "goods-title goods-title-actv"
                    : "goods-title"
                }
                style={{
                  borderBottomColor: checkedGoodsData.bg_spec_selected_border
                }}
                key={item.spec_id}
                onClick={() => checkedTitle(item.spec_id)}
              >
                {item.spec_name}
              </span>
            );
          })}
        </div>

        {/* 商品规格 */}
        <div className="goods-sc">
          <div className="goods-money-container">
            {checkedProductData.product.map((item: any) => {
              return (
                <div
                  className="goods-money-box"
                  key={item.goods_spec_id}
                  onClick={() => checkedGoodsSpec(item.goods_spec_id)}
                  style={{
                    border: `1px solid ${checkedGoodsData.bg_spec_val_border}`
                  }}
                >
                  <p className="goods-money">{item.spec_value}</p>
                  <p className="money-tip">
                    售价{item.goods_price}元
                    <br />
                    <span
                      style={{ textDecoration: "line-through", color: "#888" }}
                    >
                      {item.original_price}元
                    </span>
                  </p>

                  <img
                    src={checkedGoodsData.bg_spec_val_selected}
                    className="product-checked"
                    style={
                      item.goods_spec_id === Number(goodsSpecID)
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  />
                </div>
              );
            })}
          </div>
          <div className="goods-tip-box">
            <div className="tip-box">
              <span className="tip-m">会员充值服务说明</span>
              <div
                className="issue-icon"
                onClick={() => setShowReadme(true)}
              ></div>
            </div>
            <span className="money-log">
              {localStorage.getItem("szd_token") ? (
                <Link to="/orderlist" style={{ color: "#8d8d8d" }}>
                  充值记录
                </Link>
              ) : null}
            </span>
          </div>
        </div>

        <button
          type="button"
          className="go-money-btn"
          style={{ backgroundColor: checkedGoodsData.bg_submit }}
          onClick={() => payMoney()}
        >
          立即充值
        </button>
      </div>
      <div
        className={showReadme ? "pop-tip" : "pop-tip pop-tip-hide"}
        onClick={(e) => {
          setShowReadme(false);
        }}
      >
        <div
          className="pop-tip-main"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <h4>充值规则说明</h4>
          <div className="content">
            <h5>
              1、会员充值请输入手机号码进行充值（QQ音乐需输入QQ账号进行充值），充值完成后可用充值的账号登录官方APP进行查询到账情况。
              <br />
              2、支付前请仔细核对充值的账号，会员充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款!
              <br />
              3、会员相关权益请登录APP查看。
              <br />
              4、客服电话: 4001181216 (9: 00-18:30)
              <br />
              5、商家资质 <a href="https://szdweb.blwlkj.cn/yyzz.pdf" target="_blank">点击查看</a>
              <br />
              6、充值产品补充说明
            </h5>
            <h5>爱奇艺：</h5>
            1、黄金会员只支持电脑、手机、Pad观看会员内容。星钻VIP会员包含所有黄金VIP会员的权益，(可在电视上观看VIP影片)。
            <br />
            2、充值完成后可用充值手机号登录vip.iqiyi.com进行查询。
            <br />
            3、爱奇艺视频会员充值，除本身视频权益外，不享受其他任何权益，也不赠送其他任何会员。
            <br />
            4、支付前请仔细核对充值的手机号，视频会员充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款。
            <h5>优酷：</h5>
            1、优酷视频会员只支持电脑、手机、Pad观看会员内容，优酷SVIP会员支持电脑、手机、Pad、TV端观看会员内容
            <br />
            2、支付前请仔细核对充值的手机号，视频会员充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款!
            <br />
            3、官方地址：充值完成后可用手机号登陆查询https://home.vip.youku.com/进行查询。
            <br />
            4、本次活动仅针对优酷视频会员充值，除本身视频权益外，不享受其他任何权益，也不赠送其他任何会员。
            <h5> 腾讯视频：</h5>
            1、腾讯视频会员只支持电脑、手机、Pad观看会员内容，腾讯超级影视SVIP权益覆盖电视、电脑、手机、Pad四屏，其中电视上为云视听极光app
            <br />
            2、填写需要充值的QQ号码或手机号、支付前请仔细核对充值的QQ号码或手机号，视频会员充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款!
            <br />
            3、官方地址：充值完成后可登陆网址https://v.qq.com进行查询。
            <br />
            4、本次活动仅针对腾讯视频会员充值，除本身视频权益外，不享受其他任何权益，也不赠送其他任何会员。
            <h5>网易云音乐：</h5>
            1、网易云黑胶会员支持手机、pad、电脑端使用会员权益。
            <br />
            2、支付前请仔细核对充值的手机号，会员充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款!
            <br />
            3、官方地址：充值完成后可用手机号登陆查询https://music.163.com/进行查询。
            <br />
            4、本次活动仅针对网易云音乐会员充值，除本身权益外，不享受其他任何权益，也不赠送其他任何会员。
            <h5>美团外卖：</h5>
            1.手机号进行充值，充值成功后在美团外卖-我的-红包中查看。
            <br />
            2.红包不找零、不兑换。
            <br />
            3.成功下单后优惠码即作废，申请退款后无法退还。
            <br />
            4.每个商品单个用户账号仅可购买30次，同一设备、IP、账号、银行卡或手机号均视为同一用户。
            <br />
            5.无法使用请致电美团网客服电话：10107888（周一至周日10：00-18：00，节假日除外）。
            <h5>喜马拉雅：</h5>
            1、喜马拉雅会员支持手机、pad、电脑端使用会员权益，注意：仅支持已注册喜马拉雅账号手机号码充值！
            <br />
            2、支付前请仔细核对充值的手机号，会员充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款!
            <br />
            3、官方地址：充值完成后可用手机号登陆喜马拉雅APP进行查询。
            <br />
            4、本次活动仅针对喜马拉雅会员充值，除本身权益外，不享受其他任何权益，也不赠送其他任何会员。
            <h5>饿了么：</h5>
            1、购买前请先用充值手机号注册饿了么账号，若购买成功后7天内未注册视为自动放弃红包，会员充值金额不退还。
            <br />
            2、温馨提示∶若充值账号本身有会员，红包会在下个会员周期内发放;当月充值多笔，月卡会员后延，如本月提交2笔，本月发4张，次月生效后再发4张;查询红包到账记录，请在【我的】-【超级吃货卡】查询，查询待会员红包张数和待发放红包到账时间;超级会员兑换码兑换会员类型说明、
            <br />
            3、支付前请仔细核对充值的手机号，会员充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款!
            <br />
            4、本次活动仅针对饿了么会员充值，除本身权益外，不享受其他任何权益，也不赠送其他任何会员。
            <h5>凯叔讲故事：</h5>
            1、凯叔讲故事支持手机、pad、使用会员权益；
            <br />
            2、支付前请仔细核对充值的手机号，会员充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款!
            <br />
            3、官方地址：充值完成后可用手机号登陆凯叔讲故事APP进行查询。
            <br />
            4、本次活动仅针对凯叔讲故事会员充值，除本身权益外，不享受其他任何权益，也不赠送其他任何会员。
            <h5>奈雪：</h5>
            1、奈雪代金券成功充值后，奈雪券将实时自动充值入用户使用中国大陆地区手机号码“奈雪点单”小程序账户内。未注册“奈雪点单”账户的用户，充值成功后“奈雪点单”将会为用户自动注册
            <br />
            2、新老用户充值成功后，可打开“奈雪点单小程序，凭充值商品的手机号码登录“奈雪点单小程序-我的-奈雪券，查看券码信息。
            <br />
            3、用户消费时，打开“奈雪点单”小程序进入点餐页面，选择心仪的商品，进入支付页面时点击奈雪券在线抵扣相应的金额，若饮品券金额等于或小于消费金额，用户无需额外支付现金，若消费金额大于饮品券抵扣金额，超额部分需用户现金补差价支付。
            <h5>瑞幸：</h5>
            一、使用流程：
            <br />
            1、瑞幸咖啡饮品券商品成功充值后，饮品券将实时自动充值入用户使用中国大陆地区手机号码luckin
            coffee账户内。已下载luckin coffee
            APP且注册的用户可同时收到饮品券成功充入luckin
            coffee账户的通知。未注册luckin coffee账户的用户，充值成功后，luckin
            coffee将会为用户自动注册。
            <br /> 2、新老用户充值成功后，可直接下载/打开luckin coffee
            APP，凭充值商品的手机号码登录luckin coffee
            APP-我的-咖啡钱包，查看券码信息。 <br />
            3、用户消费时，下载/打开luckin coffee
            APP进入点餐页面，选择心仪的商品，进入支付页面时，点击“咖啡钱包”-寻找对应的瑞幸咖啡饮品券后，点击“确认”，系统会自动识别“咖啡钱包”中的饮品券金额在线抵扣相应的金额，若饮品券金额等于或小于消费金额，用户无需额外支付现金，若消费金额大于饮品券抵扣金额，超额部分需用户现金补差价支付。
            <br />
            二、注意事项：
            <br />
            1、瑞幸咖啡饮品券商品成功充值后，饮品券直接充入luckin coffee
            APP账户，用该手机号登陆luckin coffee
            APP，可在“我的”-“咖啡钱包”查看券码。
            <br />
            2、饮品券有不同的固定面值，分别对应不同档位商品价格，结算时饮品券可抵扣相应面值的商品费用，但不包含风味糖浆、奶油等辅料及配送费。
            <br />
            3、饮品券一次性使用，不设找零，超额需补差价，一次可使用多张饮品券。
            <br />
            4、本饮品券不与其他优惠叠加使用。
            <br />
            5、本产品为虚拟权益产品，兑换成功后，不退不换。
            <br />
            三、有效期： 有效期为充值成功之日起3年，具体以券码展示的为准。
            <br />
            四、服务时间： 以luckin coffee APP 显示及门店具体营业时间为准。
            <br />
            五、服务场所：支持自取及外送的大陆地区瑞幸咖啡门店6000+，具体可通过瑞幸咖啡APP-菜单-选择门店查看。
            <h5>芒果TV：</h5>
            1、芒果TV会员只支持电脑、手机、Pad观看会员内容，芒果TV全屏会员支持电脑、手机、Pad、电视端观看会员内容（不可用于海信、乐视、夏普品牌电视，其它品牌均可使用）。
            <br />
            2、支付前请仔细核对充值的手机号，视频会员充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款!
            <br />
            3、官方地址：充值完成后可用手机号登陆查询www.mgtv.com进行查询。
            <br />
            4、本次活动仅针对芒果视频会员充值，除本身视频权益外，不享受其他任何权益，也不赠送其他任何会员。
            <h5>QQ音乐：</h5>
            1、QQ音乐豪华绿钻、尊享无损音质、豪华闪电图标、个性化装扮、付费音乐播放、付费音乐下载（300首/月）等尊贵特权
            <br />
            2、充值完成后可用充值QQ登录https://y.qq.com进行查询。
            <br />
            3、本次活动仅针对QQ音乐豪华绿钻会员充值，除本身权益外，不享受其他任何权益，也不赠送其他任何会员。
            <br />
            4、支付前请仔细核对充值QQ账号，充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款!
            <h5>京东会员：</h5>
            1、支付前请仔细核对充值的账号，会员充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款!
            <br />
            2、官方地址：充值完成后可登录京东APP进行查询。
            <br />
            3、本次活动仅针对京东会员充值，除本身视频权益外，不享受其他任何权益，也不赠送其他任何会员。
            <h5>哔哩哔哩大会员：</h5>
            1、哔哩哔哩会员只支持电脑、手机、Pad观看会员内容
            <br />
            2、支付前请仔细核对充值的手机号，视频会员充值属虚拟商品，无论是否使用,一旦充值成功，本服务不支持撤销、退货、退款!
            <br />
            3、官方地址：充值完成后可用手机号登陆哔哩哔哩APP进行查询。
            <br />
            4、本次活动仅针对哔哩哔哩视频会员充值，除本身视频权益外，不享受其他任何权益，也不赠送其他任何会员。
          </div>
        </div>
        <img className="close-img" src={close} alt="" />
      </div>
    </div>
  );
};

export default UseGoodsMain;
